export interface Router {
  id: string | number;
  name: string;
  mode: string;
  sourceIp: string;
  mostragemIpv4: string;
  mostragemIpv6: string;
  snmpIp: string;
  snmpCommunity: string;
  snmpPort: string;
  fabricante?: string;
  modelo?: string;
}

export type RouterPayload = Omit<Router, "id">;

export type RouterFormErrors = Partial<Record<keyof RouterPayload, string>>;

export const ROUTER_MODES = ["nfcapd", "sfcapd"];

export const ROUTER_FIELDS: Array<keyof RouterPayload> = [
  "name",
  "mode",
  "sourceIp",
  "mostragemIpv4",
  "mostragemIpv6",
  "snmpIp",
  "snmpCommunity",
  "snmpPort",
];

export const emptyRouter: RouterPayload = {
  name: "",
  mode: "",
  sourceIp: "",
  mostragemIpv4: "",
  mostragemIpv6: "",
  snmpIp: "",
  snmpCommunity: "",
  snmpPort: "161",
};

export const DEFAULT_SNMP_PORT = 161;
export const DEFAULT_SNMP_VERSION = "SNMPv2c";

export type RouterTestType = "ping" | "snmp" | "pacotes";

export type TestsLocalState = Record<RouterTestType, boolean | null>;

export const emptyTestsLocal: TestsLocalState = {
  ping: null,
  snmp: null,
  pacotes: null,
};

export const allTestsPassed = (tests: TestsLocalState): boolean =>
  tests.ping === true && tests.snmp === true && tests.pacotes === true;

export interface RouterMassRow extends RouterPayload {
  id: string;
  dbId?: Router["id"];
  _original?: RouterPayload;
  _isNew: boolean;
  _isEdited: boolean;
  selected?: boolean;
  Status: TestsLocalState;
  _errors: RouterFormErrors;
  _loading?: boolean;
}
